import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ssoLogin } from '@chegg/one-auth-sdk';
import { createLoginThunk, sdkLoginReducers } from "./sdkLogin";
import { recordEvents, EventTypes } from "../../utils/newRelicEvents";
export var sdkSsoLogin = createLoginThunk('sdkSsoLogin', /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(state, actionParams) {
    var clientId, provider;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          clientId = state.clientId;
          recordEvents(_defineProperty({}, EventTypes.ssoLoginSent, {
            clientId: clientId,
            authType: actionParams.provider
          }));
          provider = actionParams.provider;
          _context.next = 5;
          return ssoLogin(provider, actionParams.email, actionParams.token);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
export var sdkSsoLoginReducers = {
  pending: function pending(state, action) {
    sdkLoginReducers.pending(state, action);
    var _action$meta$arg = action.meta.arg,
      provider = _action$meta$arg.provider,
      token = _action$meta$arg.token,
      email = _action$meta$arg.email,
      firstName = _action$meta$arg.firstName,
      lastName = _action$meta$arg.lastName;
    state.sso.email = email;
    state.sso.authProvider = provider;
    state.sso.authProviderToken = token;
    if (provider === 'apple' && firstName) {
      state.sso.firstName = firstName;
    }
    if (provider === 'apple' && lastName) {
      state.sso.lastName = lastName;
    }
  }
};